import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';

@Component({
  selector: 'app-whatsapp-meta',
  templateUrl: './whatsapp-meta.component.html',
  styleUrls: ['./whatsapp-meta.component.scss']
})
export class WhatsappMetaComponent implements OnInit {
  
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('Whatsapp Meta');

    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
